// --- React libraries ---
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// --- shared contexts ---
import { AuthContextProvider } from "./contexts/AuthContext";
import { QueryProvider } from "./providers/QueryProvider";
import App from "./App";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
window.React = React;
window.ReactDOM = ReactDOM as any;

import * as Lucide from "lucide-react";
(window as any).Lucide = Lucide;

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <AuthContextProvider>
      <QueryProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryProvider>
    </AuthContextProvider>
  </StrictMode>
);
